import { render } from "./CreateManual.vue?vue&type=template&id=461bb636&scoped=true"
import script from "./CreateManual.vue?vue&type=script&lang=js"
export * from "./CreateManual.vue?vue&type=script&lang=js"

import "./CreateManual.vue?vue&type=style&index=0&id=461bb636&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461bb636"]])

export default __exports__